import React, { useEffect, useState } from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { NumberStepper } from '../../../components/NumberStepper'
import { Option } from '../../../context/SeaWater/types'
import { DOBRA } from '../../../theme/fonts'
import { NetWashingDetail } from '../../../types'
import { textColor } from '../../../theme/colors'

interface Props {
  item: Option
  handleSetValue: (values: { value: number; item: Option; name: keyof NetWashingDetail }) => void
  deleteById: (id: number) => void
}

export const CategororyTwoItem = ({ item, handleSetValue, deleteById }: Props) => {
  const [showItem, setShowItem] = useState(false)

  useEffect(() => {
    if (!showItem) {
      deleteById(item.id)
    }
  }, [showItem])

  return (
    <View style={{ gap: 14 }}>
      <TouchableOpacity onPress={() => setShowItem(!showItem)}>
        <Text style={styles.titleCard}>{item.name}</Text>
      </TouchableOpacity>

      {showItem && (
        <View style={styles.container}>
          <NumberStepper
            getValue={(value) => handleSetValue({ item, name: 'm2', value })}
            label='Metros'
            symbol='m2'
            minValue={0}
          />
          <NumberStepper
            getValue={(value) => handleSetValue({ item, name: 'cageCount', value })}
            label='Cantidad Jaulas'
            minValue={0}
          />
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
    gap: 16,
  },
  titleCard: {
    fontFamily: DOBRA,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    textAlign: 'left',
    marginTop: 8,
    color: textColor,
  },
})
